import $ from "jquery";
import "../bootstrap.js";
window.$ = $;
window.jQuery = $;

document.addEventListener("DOMContentLoaded", async () => {
    const liveEls = document.querySelectorAll(".js-live-slider");
    const { renderLiveSlider } = await import("../components/slider.js");

    liveEls.forEach((el) => {
        renderLiveSlider(el);
    });

    const anchorEl = document.querySelectorAll(".handle-anchor");
    if (anchorEl) {
        const { initAnchorLink } = await import("../components/anchorlink.js");
        initAnchorLink();
    }
    const popupEl = document.querySelector(".popup-detail");

    if (popupEl) {
        const { openPopup } = await import("../components/modal.js");
        openPopup();
    }
});
